import { Link } from "react-router-dom";
import type { MediaTitle } from "@/types/media";
import { formatHeat } from "@/lib/media";

interface HotRankingProps {
  items: MediaTitle[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <ul className="space-y-1">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors"
            >
              <span
                className={`w-7 h-7 rounded-md flex items-center justify-center text-sm font-extrabold font-heading shrink-0 ${
                  i < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="w-10 h-14 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={`${item.title} 影视详情`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
                <p className="text-[11px] text-foreground-500 truncate mt-0.5">
                  {item.region} · {item.genres.slice(0, 2).join(" / ")}
                </p>
              </div>
              <div className="text-right shrink-0">
                <div className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600">
                  <i className="ri-fire-fill" />
                  {formatHeat(item.heat)}
                </div>
                <div className="text-[11px] text-foreground-400 mt-0.5">
                  {item.rating.toFixed(1)} 分
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}